<template>
    <CalcCard
        wide
        step="§calc.step3.eyebrow"
        title="§calc.step3.title"
        subtitle="§calc.step3.subtitle"
    >
        <template v-if="result">
            <CalcPreviewTable :result="result" :billing-label="billingLabelKey" />

            <CalcPdfCard
                :download-state="downloadState"
                :disabled="!result"
                :project-name="data.projectName"
                @update:project-name="$emit('update:data', { projectName: $event })"
                @download="$emit('download')"
            />
        </template>

        <div class="calc-btn-row calc-step3__nav">
            <CalcButton
                variant="secondary"
                label="§calc.step3.cta.back"
                @click="$emit('back')"
            />
            <CalcButton
                variant="bare"
                label="§calc.step3.cta.restart"
                @click="$emit('restart')"
            />
        </div>

        <!-- CFO Toolbox CTA disabled — destination not finalised -->
        <!-- <div class="calc-divider" /> -->

        <!-- <CalcCfoCard @get-started="$emit('get-started')" /> -->

        <div class="calc-btn-row calc-btn-row--end calc-step3__book">
            <CalcButton
                variant="primary"
                label="§calc.step3.cta.book"
                icon-name="phone"
                icon-color="white"
                @click="$emit('book-call')"
            />
        </div>
    </CalcCard>
</template>

<script>
import CalcCard from '../components/CalcCard.vue'
import CalcPreviewTable from '../components/CalcPreviewTable.vue'
import CalcPdfCard from '../components/CalcPdfCard.vue'
// import CalcCfoCard from '../components/CalcCfoCard.vue' // CFO Toolbox disabled
import CalcButton from '../components/CalcButton.vue'
import { calculateOffer } from '../services/calc.js'
import { getBillingLabelKey } from '../data/billingLabelKeys.js'

export default {
    name: 'CalcStep3',

    components: {
        CalcCard,
        CalcPreviewTable,
        CalcPdfCard,
        // CalcCfoCard, // CFO Toolbox disabled
        CalcButton,
    },

    props: {
        data: {
            type: Object,
            required: true,
        },
        downloadState: {
            type: String,
            default: 'idle',
        },
    },

    emits: ['update:data', 'back', 'restart', /* 'get-started', */ 'book-call', 'download'],

    computed: {
        result() {
            return calculateOffer(this.data)
        },

        billingLabelKey() {
            return getBillingLabelKey(this.data.billing)
        },
    },
}
</script>

<style scoped>
.calc-step3__nav {
    margin-top: 24px;
}

.calc-step3__book {
    margin-top: 28px;
}

.calc-divider {
    height: 1px;
    background: var(--calc-line);
    margin: 24px -99px 32px;
    border: none;
}

@media (max-width: 760px) {
    .calc-divider {
        margin: 24px -22px 28px;
    }
}
</style>
